import React, { useState } from 'react';
import { Box, Button, Text, useDisclosure, Flex } from '@chakra-ui/react';
import { HiOutlineDownload } from 'react-icons/hi';
import { RiShareForwardLine } from 'react-icons/ri';
import { useResumes } from '../../../hooks/V2/useUser';
import dayjs from 'dayjs';
import ShareModal from '../../common/V2/SocialMedia/ShareModal';

export const OldUserResume = () => {
	const [shareResume, setShareResume] = useState();
	const { isOpen, onClose, onOpen } = useDisclosure();

	const { data: resumes } = useResumes();

	return (
		<Box>
			<Text textStyle={{ base: 'body1-md', md: 'h3' }} fontFamily={'Open Sans'} color={'#03081A'} textAlign={{ base: 'start', md: 'center' }}>
				My Resumes
			</Text>
			<Box mt="16px" w={'100%'} gap={'24px'} display="flex" flexWrap="wrap">
				{
					// @ts-ignore
					resumes &&
						resumes?.length > 0 &&
						resumes.map((el: any) => (
							<Box mx={{ base: 'auto', md: '0px' }} w="full" maxW={'361px'}>
								<Box border="0.847px solid #CECCCD" bg="#FFF" p={'10px'} borderRadius={'12px'}>
									<Box bg="#F7F7FF" border="0.847px solid #E7E6E6" borderRadius={'12px'}>
										{/* <Image
											src={el.resumeImg}
											width="100%"
											height="152px"
											style={{ borderTopRightRadius: '12px', borderTopLeftRadius: '12px' }}
											title={el.name}
										></Image> */}
										<Box bgColor={'#6E71CC'} boxSize={'140px'} width={'100%'} borderTopRadius={'12px'}></Box>
										<Box pt={'6px'} pl="12px" pr="12px" pb="6px">
											<Text textStyle={'body2-md'}>{el.header}.pdf</Text>
											<Flex alignItems={'center'} gap={'2px'}>
												<Text textStyle={'caption'} color={'#6C6768'}>
													Generated on :
												</Text>
												<Text fontWeight={'600'} lineHeight={'21px'} fontSize={'14px'} color="#21191B">
													{' '}
													{dayjs(el.createdAt).format('DD/MM/YYYY')}
												</Text>
											</Flex>
										</Box>
									</Box>
									<Box textAlign={'right'} mt="12px">
										<Button
											bg={'#F2F6FF'}
											mr={'12px'}
											size={'sm'}
											fontSize={'12px'}
											fontWeight={'600'}
											border={'none'}
											alignItems={'center'}
											color="#0A0103"
											padding={'6px 10px'}
											textTransform={'capitalize'}
											borderRadius={'6px'}
											// href={}
											cursor="pointer"
											// download={el.pdfUrl}
											// isDisabled={!el?.template}
											onClick={() => {
												window.location.href = el?.template?.name
													? `https://resume-api-new.masaischool.com/profile/download/resume?resumeId=${el._id}&templateName=${el?.template?.name}`
													: `https://resume-api-new.masaischool.com/profile/download/resume?resumeId=${el._id}`;
											}}
										>
											Download
											<HiOutlineDownload fontSize={'14px'} style={{ marginLeft: '4px' }} />{' '}
										</Button>
										<Button
											bg={'#F2F6FF'}
											mr={'12px'}
											size={'sm'}
											as="a"
											border={'none'}
											alignItems={'center'}
											fontSize={'12px'}
											color="#0A0103"
											padding={'6px 10px'}
											borderRadius={'6px'}
											textTransform={'capitalize'}
											onClick={() => {
												setShareResume(el);
												onOpen();
											}}
											cursor="pointer"
										>
											Share <RiShareForwardLine fontSize={'14px'} style={{ marginLeft: '4px' }} />
										</Button>
									</Box>
								</Box>
							</Box>
						))
				}
			</Box>

			{shareResume && (
				<ShareModal
					isOpen={isOpen}
					onClose={onClose}
					// @ts-ignore
					shareUrl={`https://resume-api-new.masaischool.com/profile/download/resume?resumeId=%${shareResume?._id}%22&templateName=${shareResume?.template?.name}`}
				/>
			)}
		</Box>
	);
};

export default OldUserResume;
